import React from "react";
import { FiCommand, FiBookOpen, FiUsers, FiUser, FiShield, FiCpu, FiGlobe, FiMapPin, FiCheckCircle } from "react-icons/fi";
import "../../styles/AboutSection.css";

export default function GovernanceSection() {
  return (
    <section className="about-sub-section governance-section" id="gouvernance">
      <div className="section-header-v2">
        <span className="accent-line"></span>
        <h2>GOUVERNANCE</h2>
      </div>

      <div className="governance-intro">
        <p>L'Institut IAMAR adopte un modèle de gouvernance structuré, fondé sur la complémentarité entre pilotage stratégique, excellence scientifique et expertise opérationnelle.</p>
      </div>

      <div className="governance-architecture-grid">
        {/* Direction de l'Institut */}
        <div className="gov-architecture-block direction-main-container" id="direction">
          <div className="architecture-label">Pilotage Stratégique</div>
          <div className="gov-block-title-row">
            <FiCommand className="gov-icon" />
            <h3>Direction de l'Institut</h3>
          </div>
          
          <div className="direction-content-box">
            <div className="direction-info-group">
              <h4>Rôle et mission</h4>
              <p>La Direction assure la définition des orientations stratégiques et le pilotage des activités de l'Institut.</p>
              <ul className="gov-check-list">
                <li><FiCheckCircle /> Cohérence scientifique et institutionnelle</li>
                <li><FiCheckCircle /> Alignement avec les standards mondiaux</li>
                <li><FiCheckCircle /> Positionnement stratégique global</li>
              </ul>
            </div>

            <div className="attributions-container">
              <h4>Attributions clés</h4>
              <div className="attributions-grid">
                <div className="attr-item">Axes stratégiques</div>
                <div className="attr-item">Validation programmes</div>
                <div className="attr-item">Supervision publications</div>
                <div className="attr-item">Coordination GSIDA</div>
                <div className="attr-item">Partenariats</div>
              </div>
            </div>
          </div>
        </div>

        {/* Comité Scientifique */}
        <div className="gov-architecture-block committee-main-container" id="comite-scientifique">
          <div className="architecture-label">Excellence Scientifique</div>
          <div className="gov-block-title-row">
            <FiBookOpen className="gov-icon" />
            <h3>Comité Scientifique</h3>
          </div>
          <p className="mission-tag">Organe central de validation académique et garantie de la qualité.</p>
          
          <div className="committee-grid">
            <div className="validation-roles">
              <div className="missions-scientific-escalier">
                <div className="escalier-card escalier-step-1">
                  <span className="step-tag">Phase 01</span>
                  <div className="escalier-text">Validation des orientations de recherche</div>
                </div>
                <div className="escalier-card escalier-step-2">
                  <span className="step-tag">Phase 02</span>
                  <div className="escalier-text">Évaluation des productions scientifiques</div>
                </div>
                <div className="escalier-card escalier-step-3">
                  <span className="step-tag">Phase 03</span>
                  <div className="escalier-text">Sélection des communications GSIDA</div>
                </div>
              </div>
            </div>

            <div className="composition-box">
              <h5>Composition Internationale</h5>
              <div className="composition-tags">
                <span><FiUser /> Académiques</span>
                <span><FiShield /> Experts</span>
                <span><FiCpu /> Spécialistes</span>
                <span><FiGlobe /> Consultants</span>
              </div>
            </div>
          </div>

          <div className="values-footer">
            <span>Rigueur</span>
            <span>Légitimité</span>
            <span>Excellence</span>
          </div>
        </div>

        {/* Experts Associés */}
        <div className="gov-architecture-block experts-main-container" id="experts-associes">
          <div className="architecture-label">Expertise Opérationnelle</div>
          <div className="gov-block-title-row">
            <FiUsers className="gov-icon" />
            <h3>Experts Associés</h3>
          </div>
          
          <div className="experts-typology-container">
            <div className="expert-typology-item">
              <FiMapPin className="type-icon" />
              <div className="type-text">
                <h5>Institutionnels</h5>
                <p>Responsables de sécurité, cadres publics.</p>
              </div>
            </div>
            <div className="expert-typology-item">
              <FiGlobe className="type-icon" />
              <div className="type-text">
                <h5>Internationaux</h5>
                <p>Consultants, gestion des crises.</p>
              </div>
            </div>
            <div className="expert-typology-item">
              <FiCpu className="type-icon" />
              <div className="type-text">
                <h5>Technologiques</h5>
                <p>Cybersécurité, Intelligence Artificielle.</p>
              </div>
            </div>
            <div className="expert-typology-item">
              <FiBookOpen className="type-icon" />
              <div className="type-text">
                <h5>Académiques</h5>
                <p>Enseignants-chercheurs, Doctorants.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
